import { makeStyles } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React, { useMemo } from 'react';
import { useBoolean } from 'react-use-boolean';
import { Dialog } from '../common/Dialog';
import { IconButton } from '../common/IconButton';
import { useGalleryContext } from './GalleryContext';
import { LeaveGalleryEditorModal } from './LeaveGalleryEditorModal';
import { SaveGalleryModals, useSaveGallery } from './SaveGalleryModals';

const useStyle = makeStyles({
  closeButton: {
    margin: 8,
    '& svg': {
      fill: 'white',
      fontSize: 32,
    },
  },
});

export const LeaveGalleryEditor = () => {
  const styles = useStyle();
  const [open, actions] = useBoolean();
  const { newPanoramas, currentFolder, currentGallery, waypointsShown } = useGalleryContext();
  // NOTE: do not change "() => window.close()" to just "window.close"
  const saveGallery = useSaveGallery({
    panoramaDetails: newPanoramas,
    onSaveSuccess: () => window.close(),
    waypointsShown,
  });

  const hasGalleryChanged = useMemo(() => {
    if (!currentGallery || currentGallery.panoramas.length !== newPanoramas.length) {
      return true;
    }
    if (currentGallery.tourMode !== waypointsShown) {
      return true;
    }
    return !currentGallery.panoramas.every(
      (p, index) => newPanoramas[index].panoramaGuid === p.panoramaGuid,
    );
  }, [currentGallery, newPanoramas, waypointsShown]);

  const onLeaveClick = hasGalleryChanged ? actions.on : window.close;

  const saveEnabled = newPanoramas.length >= 2;

  if (!currentFolder) {
    return null;
  }

  return (
    <>
      <IconButton
        onClick={onLeaveClick}
        variant={'close'}
        aria-label='leave editor'
        icon={<Close />}
        className={styles.closeButton}
      />
      <Dialog open={open} onClose={actions.off}>
        <LeaveGalleryEditorModal
          saveEnabled={saveEnabled}
          onClose={actions.off}
          onContinue={actions.off}
          onLeave={window.close}
          onSave={() => {
            actions.off();
            saveGallery.onSave();
          }}
        />
      </Dialog>
      <SaveGalleryModals
        {...saveGallery}
        currentFolder={currentFolder}
        waypointsShown={waypointsShown}
      />
    </>
  );
};
